import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgArrowUp = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.672 9.45c.304.3.796.3 1.1 0a.76.76 0 0 0 0-1.086l-6.222-6.14a.78.78 0 0 0-.848-.166.8.8 0 0 0-.252.167l-6.222 6.14a.76.76 0 0 0 0 1.085c.304.3.796.3 1.1 0l4.894-4.83v16.613c0 .423.348.767.778.767s.778-.344.778-.767V4.62z"
      />
    </svg>
  );
};
export default SvgArrowUp;
